import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'

const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const immobilisationsCédéesSlice = createSlice({
    name: 'immobilisationsCédées',
    initialState: {
        data: [],
        detailsImmobilisationsCédées: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchDetailsImmobilisationsCédées.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchDetailsImmobilisationsCédées.fulfilled, (state, action) => {
            const currentPage = action?.meta?.arg?.page || state.currentPage;

            state.currentPage = currentPage
            state.isLoading = false
            state.detailsImmobilisationsCédées = action.payload
        })
        .addCase(fetchDetailsImmobilisationsCédées.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message
        })
            .addCase(fetchImmobilisationsCédées.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchImmobilisationsCédées.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchImmobilisationsCédées.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            .addCase(createImmobilisationsCédée.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(createImmobilisationsCédée.fulfilled, (state, action) => {
                state.isLoading = false
                state.created = true
            })
            .addCase(createImmobilisationsCédée.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.created = false
            })
            .addCase(deleteImmobilisationsCédée.pending, (state) => {
                state.isLoading = true
                state.isDeleted = null
            })
            .addCase(deleteImmobilisationsCédée.fulfilled, (state) => {
                state.isLoading = false
                state.isDeleted = true
            })
            .addCase(deleteImmobilisationsCédée.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
                state.isDeleted = false
            })
    },
})

// Async thunk action to fetch data from the API
export const fetchImmobilisationsCédées = createAsyncThunk(
    'immobilisationsCédées/fetch',
    async (payload) => {
        const page = payload?.page || 1
        const limit = payload?.limit || LIMIT
        const search = payload?.search || ''
        const statut_f = payload?.statut_f || ''
        let date_d_f = payload?.date?.[0] || ''
        let date_f_f = payload?.date?.[1] || ''
        if (dayjs(date_d_f).isValid() && dayjs(date_f_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
        } else if (dayjs(date_d_f).isValid()) {
            date_d_f = dayjs(date_d_f).format('YYYY-MM-DD');
            date_f_f = date_d_f;
        } else if (dayjs(date_f_f).isValid()) {
            date_f_f = dayjs(date_f_f).format('YYYY-MM-DD');
            date_d_f = date_f_f;
        }
        try {
            const response = await BaseService.get(
                `/XML/imv.load?page=${page}&limit=${limit}&text=${search}&statut_f=${statut_f}&date_d_f=${date_d_f}&date_f_f=${date_f_f}`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch immobilisationsCédées')
        }
    }
)
// Async thunk action to fetch details from the API
export const fetchDetailsImmobilisationsCédées = createAsyncThunk(
    'ImmobilisationsCédées/fetchDetails',
    async (id) => {
        const data = {'idim':id.id}
        try {
            const ImmobilisationsCédée = await BaseService.post(
                `/XML/imv.load/get_one_immo`,data
            )
            const Client = await BaseService.post(
                `/XML/ve.cl.load/get_one_cl`,{'idcl':ImmobilisationsCédée.data?.[0]?.idcl}
            )

            if (ImmobilisationsCédée.data[0]) {
                ImmobilisationsCédée.data[0]['operateur'] = ImmobilisationsCédée.data[0]['nom_utilisateur'] + ' ' + ImmobilisationsCédée.data[0]['prenom']
            }
            return {ImmobilisationsCédée:ImmobilisationsCédée.data,Client:Client.data}
        } catch (error) {
            throw new Error('Failed to fetch ImmobilisationsCédées')
        }
    }
)
export const createImmobilisationsCédée = createAsyncThunk(
    'immobilisationsCédées/post',
    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/immobilisationsCédées', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                navigate('/immobilisationsCédées')
            }
        } catch (err) {
            console.log({ err })
            
            setSubmitting(false)
            
            popNotification(creation?.error)
        }
    }
)

export const editImmobilisationsCédée = createAsyncThunk('immobilisationsCédées/edit', async (payload) => {
    const { data, formik, navigate } = payload
    const { resetForm, setSubmitting } = formik
    try {
        const response = await BaseService.put(`/immobilisationsCédées/${data?.id}`, data)
        if (response.status === 200) {
            resetForm()
            setSubmitting(false)
            popNotification(edit?.success)
            navigate('/immobilisationsCédées')
        }
    } catch (err) {
        console.log({ err })
        
        popNotification(edit?.error)
    }
})

export const deleteImmobilisationsCédée = createAsyncThunk(
    'immobilisationsCédée/delete',
    async (payload) => {
        const { id, setImmobilisationsCédéeAdded } = payload
             
             try {
                 const response = await BaseService.post('/XML/imv.send/delete', {'id':id})
                 if (response.status === 200) {
                    
                     popNotification(creation?.success)
                     setImmobilisationsCédéeAdded(true)
                 }
             } catch (err) {
                 console.log({ err })
                 
                 popNotification(creation?.error)
             }
         }
)

export const selectData = (state) => state.immobilisationsCédées.data
export const selectIsLoading = (state) => state.immobilisationsCédées.isLoading
export const selectError = (state) => state.immobilisationsCédées.error
export const selectIsDeleted = (state) => state.immobilisationsCédées.isDeleted
export const selectCurrentPage = (state) => state.immobilisationsCédées.currentPage

export default immobilisationsCédéesSlice.reducer
